// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BnFY","index":"styles_index__KPE-w"};